//Imports
import {
  STAFF_PLANNER_LIST_REQUEST,
  STAFF_PLANNER_LIST_SUCCESS,
  STAFF_PLANNER_LIST_FAIL,
  STAFF_PLANNER_DATA_REQUEST,
  STAFF_PLANNER_DATA_SUCCESS,
  STAFF_PLANNER_DATA_FAIL,
  STAFF_PLANNER_CREATE_REQUEST,
  STAFF_PLANNER_CREATE_SUCCESS,
  STAFF_PLANNER_CREATE_FAIL,
  STAFF_PLANNER_UPDATE_REQUEST,
  STAFF_PLANNER_UPDATE_SUCCESS,
  STAFF_PLANNER_UPDATE_FAIL,
  STAFF_PLANNER_DELETE_REQUEST,
  STAFF_PLANNER_DELETE_SUCCESS,
  STAFF_PLANNER_DELETE_FAIL,
  STAFF_PLANNER_SEARCH_REQUEST,
  STAFF_PLANNER_SEARCH_SUCCESS,
  STAFF_PLANNER_SEARCH_FAIL,
  STAFF_PLANNER_COMPLETE_REQUEST,
  STAFF_PLANNER_COMPLETE_SUCCESS,
  STAFF_PLANNER_COMPLETE_FAIL,
  STAFF_PLANNER_UNINVOICED_REQUEST,
  STAFF_PLANNER_UNINVOICED_SUCCESS,
  STAFF_PLANNER_UNINVOICED_FAIL,
  STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST,
  STAFF_PLANNER_CONVERT_TO_INVOICE_SUCCESS,
  STAFF_PLANNER_CONVERT_TO_INVOICE_FAIL,
  STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST,
  STAFF_PLANNER_GENERATE_RECURRENCE_SUCCESS,
  STAFF_PLANNER_GENERATE_RECURRENCE_FAIL,
  STAFF_PLANNER_STATUS_LIST_REQUEST,
  STAFF_PLANNER_STATUS_LIST_SUCCESS,
  STAFF_PLANNER_STATUS_LIST_FAIL,
  STAFF_PLANNER_RECENT_ACTIVITY_REQUEST,
  STAFF_PLANNER_RECENT_ACTIVITY_SUCCESS,
  STAFF_PLANNER_RECENT_ACTIVITY_FAIL,
  STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_LIST_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_LIST_FAIL,
  STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_DATA_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_DATA_FAIL,
  STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_CREATE_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_CREATE_FAIL,
  STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_UPDATE_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_UPDATE_FAIL,
  STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_DELETE_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_DELETE_FAIL,
  STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_ASSIGN_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_ASSIGN_FAIL,
  STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST,
  STAFF_PLANNER_ASSIGNMENT_UNASSIGN_SUCCESS,
  STAFF_PLANNER_ASSIGNMENT_UNASSIGN_FAIL,
} from "./actionType";

//Initial State
const initialState = {
  // Use 3 properties per each data loading error

  staffPlannerList: [],
  staffPlannerListLoading: false,
  staffPlannerListError: null,

  staffPlannerData: null,
  staffPlannerDataLoading: false,
  staffPlannerDataError: null,

  staffPlannerCreateSuccess: [],
  staffPlannerCreateLoading: false,
  staffPlannerCreateError: null,

  staffPlannerUpdateSuccess: [],
  staffPlannerUpdateLoading: false,
  staffPlannerUpdateError: null,

  staffPlannerDeleteSuccess: [],
  staffPlannerDeleteLoading: false,
  staffPlannerDeleteError: null,

  staffPlannerSearch: [],
  staffPlannerSearchLoading: false,
  staffPlannerSearchError: null,

  staffPlannerCompleteSuccess: [],
  staffPlannerCompleteLoading: false,
  staffPlannerCompleteError: null,

  staffPlannerGenerateRecurrenceSuccess: [],
  staffPlannerGenerateRecurrenceLoading: false,
  staffPlannerGenerateRecurrenceError: null,

  staffPlannerStatusList: [],
  staffPlannerStatusListLoading: false,
  staffPlannerStatusListError: null,

  staffPlannerRecentActivity: [],
  staffPlannerRecentActivityLoading: false,
  staffPlannerRecentActivityError: null,

  staffPlannerAssignmentList: [],
  staffPlannerAssignmentListLoading: false,
  staffPlannerAssignmentListError: null,

  staffPlannerAssignmentData: null,
  staffPlannerAssignmentDataLoading: false,
  staffPlannerAssignmentDataError: null,

  staffPlannerAssignmentCreateSuccess: [],
  staffPlannerAssignmentCreateLoading: false,
  staffPlannerAssignmentCreateError: null,

  staffPlannerAssignmentUpdateSuccess: [],
  staffPlannerAssignmentUpdateLoading: false,
  staffPlannerAssignmentUpdateError: null,

  staffPlannerAssignmentDeleteSuccess: [],
  staffPlannerAssignmentDeleteLoading: false,
  staffPlannerAssignmentDeleteError: null,

  staffPlannerAssignmentAssignSuccess: [],
  staffPlannerAssignmentAssignLoading: false,
  staffPlannerAssignmentAssignError: null,

  staffPlannerAssignmentUnassignSuccess: [],
  staffPlannerAssignmentUnassignLoading: false,
  staffPlannerAssignmentUnassignError: null,
};

//Reducer

export const staffPlanner = (state = initialState, action) => {
  switch (action.type) {
    //STAFF_PLANNER_LIST
    case STAFF_PLANNER_LIST_REQUEST:
      return {
        ...state,
        staffPlannerListLoading: true,
        staffPlannerListError: null,
      };
    case STAFF_PLANNER_LIST_SUCCESS:
      return {
        ...state,
        staffPlannerListLoading: false,
        staffPlannerList: action.payload,
      };
    case STAFF_PLANNER_LIST_FAIL:
      return {
        ...state,
        staffPlannerListLoading: false,
        staffPlannerListError: action.payload,
      };
    //STAFF_PLANNER_DATA
    case STAFF_PLANNER_DATA_REQUEST:
      return {
        ...state,
        staffPlannerDataLoading: true,
        staffPlannerDataError: null,
      };
    case STAFF_PLANNER_DATA_SUCCESS:
      return {
        ...state,
        staffPlannerDataLoading: false,
        staffPlannerData: action.payload,
      };
    case STAFF_PLANNER_DATA_FAIL:
      return {
        ...state,
        staffPlannerDataLoading: false,
        staffPlannerDataError: action.payload,
      };
    //STAFF_PLANNER_CREATE
    case STAFF_PLANNER_CREATE_REQUEST:
      return {
        ...state,
        staffPlannerCreateLoading: true,
        staffPlannerCreateError: null,
      };
    case STAFF_PLANNER_CREATE_SUCCESS:
      return {
        ...state,
        staffPlannerCreateLoading: false,
        staffPlannerCreateSuccess: action.payload,
      };
    case STAFF_PLANNER_CREATE_FAIL:
      return {
        ...state,
        staffPlannerCreateLoading: false,
        staffPlannerCreateError: action.payload,
      };
    //STAFF_PLANNER_UPDATE
    case STAFF_PLANNER_UPDATE_REQUEST:
      return {
        ...state,
        staffPlannerUpdateLoading: true,
        staffPlannerUpdateError: null,
      };
    case STAFF_PLANNER_UPDATE_SUCCESS:
      return {
        ...state,
        staffPlannerUpdateLoading: false,
        staffPlannerUpdateSuccess: action.payload,
      };
    case STAFF_PLANNER_UPDATE_FAIL:
      return {
        ...state,
        staffPlannerUpdateLoading: false,
        staffPlannerUpdateError: action.payload,
      };
    //STAFF_PLANNER_DELETE
    case STAFF_PLANNER_DELETE_REQUEST:
      return {
        ...state,
        staffPlannerDeleteLoading: true,
        staffPlannerDeleteError: null,
      };
    case STAFF_PLANNER_DELETE_SUCCESS:
      return {
        ...state,
        staffPlannerDeleteLoading: false,
        staffPlannerDeleteSuccess: action.payload,
      };
    case STAFF_PLANNER_DELETE_FAIL:
      return {
        ...state,
        staffPlannerDeleteLoading: false,
        staffPlannerDeleteError: action.payload,
      };
    //STAFF_PLANNER_SEARCH
    case STAFF_PLANNER_SEARCH_REQUEST:
      return {
        ...state,
        staffPlannerSearchLoading: true,
        staffPlannerSearchError: null,
      };
    case STAFF_PLANNER_SEARCH_SUCCESS:
      return {
        ...state,
        staffPlannerSearchLoading: false,
        staffPlannerSearch: action.payload,
      };
    case STAFF_PLANNER_SEARCH_FAIL:
      return {
        ...state,
        staffPlannerSearchLoading: false,
        staffPlannerSearchError: action.payload,
      };
    //STAFF_PLANNER_COMPLETE
    case STAFF_PLANNER_COMPLETE_REQUEST:
      return {
        ...state,
        staffPlannerCompleteLoading: true,
        staffPlannerCompleteError: null,
      };
    case STAFF_PLANNER_COMPLETE_SUCCESS:
      return {
        ...state,
        staffPlannerCompleteLoading: false,
        staffPlannerCompleteSuccess: action.payload,
      };
    case STAFF_PLANNER_COMPLETE_FAIL:
      return {
        ...state,
        staffPlannerCompleteLoading: false,
        staffPlannerCompleteError: action.payload,
      };
    //STAFF_PLANNER_UNINVOICED
    case STAFF_PLANNER_UNINVOICED_REQUEST:
      return {
        ...state,
        staffPlannerUninvoicedLoading: true,
        staffPlannerUninvoicedError: null,
      };
    case STAFF_PLANNER_UNINVOICED_SUCCESS:
      return {
        ...state,
        staffPlannerUninvoicedLoading: false,
        staffPlannerUninvoiced: action.payload,
      };
    case STAFF_PLANNER_UNINVOICED_FAIL:
      return {
        ...state,
        staffPlannerUninvoicedLoading: false,
        staffPlannerUninvoicedError: action.payload,
      };
    //STAFF_PLANNER_CONVERT_TO_INVOICE
    case STAFF_PLANNER_CONVERT_TO_INVOICE_REQUEST:
      return {
        ...state,
        staffPlannerConvertToInvoiceLoading: true,
        staffPlannerConvertToInvoiceError: null,
      };
    case STAFF_PLANNER_CONVERT_TO_INVOICE_SUCCESS:
      return {
        ...state,
        staffPlannerConvertToInvoiceLoading: false,
        staffPlannerConvertToInvoice: action.payload,
      };
    case STAFF_PLANNER_CONVERT_TO_INVOICE_FAIL:
      return {
        ...state,
        staffPlannerConvertToInvoiceLoading: false,
        staffPlannerConvertToInvoiceError: action.payload,
      };
    //STAFF_PLANNER_GENERATE_RECURRENCE
    case STAFF_PLANNER_GENERATE_RECURRENCE_REQUEST:
      return {
        ...state,
        staffPlannerGenerateRecurrenceLoading: true,
        staffPlannerGenerateRecurrenceError: null,
      };
    case STAFF_PLANNER_GENERATE_RECURRENCE_SUCCESS:
      return {
        ...state,
        staffPlannerGenerateRecurrenceLoading: false,
        staffPlannerGenerateRecurrenceSuccess: action.payload,
      };
    case STAFF_PLANNER_GENERATE_RECURRENCE_FAIL:
      return {
        ...state,
        staffPlannerGenerateRecurrenceLoading: false,
        staffPlannerGenerateRecurrenceError: action.payload,
      };
    //STAFF_PLANNER_STATUS_LIST
    case STAFF_PLANNER_STATUS_LIST_REQUEST:
      return {
        ...state,
        staffPlannerStatusListLoading: true,
        staffPlannerStatusListError: null,
      };
    case STAFF_PLANNER_STATUS_LIST_SUCCESS:
      return {
        ...state,
        staffPlannerStatusListLoading: false,
        staffPlannerStatusList: action.payload,
      };
    case STAFF_PLANNER_STATUS_LIST_FAIL:
      return {
        ...state,
        staffPlannerStatusListLoading: false,
        staffPlannerStatusListError: action.payload,
      };
    //STAFF_PLANNER_RECENT_ACTIVITY
    case STAFF_PLANNER_RECENT_ACTIVITY_REQUEST:
      return {
        ...state,
        staffPlannerRecentActivityLoading: true,
        staffPlannerRecentActivityError: null,
      };
    case STAFF_PLANNER_RECENT_ACTIVITY_SUCCESS:
      return {
        ...state,
        staffPlannerRecentActivityLoading: false,
        staffPlannerRecentActivity: action.payload,
      };
    case STAFF_PLANNER_RECENT_ACTIVITY_FAIL:
      return {
        ...state,
        staffPlannerRecentActivityLoading: false,
        staffPlannerRecentActivityError: action.payload,
      };
    //STAFF_PLANNER_ASSIGNMENT_LIST
    case STAFF_PLANNER_ASSIGNMENT_LIST_REQUEST:
      return {
        ...state,
        staffPlannerAssignmentListLoading: true,
        staffPlannerAssignmentListError: null,
      };
    case STAFF_PLANNER_ASSIGNMENT_LIST_SUCCESS:
      return {
        ...state,
        staffPlannerAssignmentListLoading: false,
        staffPlannerAssignmentList: action.payload,
      };
    case STAFF_PLANNER_ASSIGNMENT_LIST_FAIL:
      return {
        ...state,
        staffPlannerAssignmentListLoading: false,
        staffPlannerAssignmentListError: action.payload,
      };
    //STAFF_PLANNER_ASSIGNMENT_DATA
    case STAFF_PLANNER_ASSIGNMENT_DATA_REQUEST:
      return {
        ...state,
        staffPlannerAssignmentDataLoading: true,
        staffPlannerAssignmentDataError: null,
      };
    case STAFF_PLANNER_ASSIGNMENT_DATA_SUCCESS:
      return {
        ...state,
        staffPlannerAssignmentDataLoading: false,
        staffPlannerAssignmentData: action.payload,
      };
    case STAFF_PLANNER_ASSIGNMENT_DATA_FAIL:
      return {
        ...state,
        staffPlannerAssignmentDataLoading: false,
        staffPlannerAssignmentDataError: action.payload,
      };
    //STAFF_PLANNER_ASSIGNMENT_CREATE
    case STAFF_PLANNER_ASSIGNMENT_CREATE_REQUEST:
      return {
        ...state,
        staffPlannerAssignmentCreateLoading: true,
        staffPlannerAssignmentCreateError: null,
      };
    case STAFF_PLANNER_ASSIGNMENT_CREATE_SUCCESS:
      return {
        ...state,
        staffPlannerAssignmentCreateLoading: false,
        staffPlannerAssignmentCreateSuccess: action.payload,
      };
    case STAFF_PLANNER_ASSIGNMENT_CREATE_FAIL:
      return {
        ...state,
        staffPlannerAssignmentCreateLoading: false,
        staffPlannerAssignmentCreateError: action.payload,
      };
    //STAFF_PLANNER_ASSIGNMENT_UPDATE
    case STAFF_PLANNER_ASSIGNMENT_UPDATE_REQUEST:
      return {
        ...state,
        staffPlannerAssignmentUpdateLoading: true,
        staffPlannerAssignmentUpdateError: null,
      };
    case STAFF_PLANNER_ASSIGNMENT_UPDATE_SUCCESS:
      return {
        ...state,
        staffPlannerAssignmentUpdateLoading: false,
        staffPlannerAssignmentUpdateSuccess: action.payload,
      };
    case STAFF_PLANNER_ASSIGNMENT_UPDATE_FAIL:
      return {
        ...state,
        staffPlannerAssignmentUpdateLoading: false,
        staffPlannerAssignmentUpdateError: action.payload,
      };
    //STAFF_PLANNER_ASSIGNMENT_DELETE
    case STAFF_PLANNER_ASSIGNMENT_DELETE_REQUEST:
      return {
        ...state,
        staffPlannerAssignmentDeleteLoading: true,
        staffPlannerAssignmentDeleteError: null,
      };
    case STAFF_PLANNER_ASSIGNMENT_DELETE_SUCCESS:
      return {
        ...state,
        staffPlannerAssignmentDeleteLoading: false,
        staffPlannerAssignmentDeleteSuccess: action.payload,
      };
    case STAFF_PLANNER_ASSIGNMENT_DELETE_FAIL:
      return {
        ...state,
        staffPlannerAssignmentDeleteLoading: false,
        staffPlannerAssignmentDeleteError: action.payload,
      };
    //STAFF_PLANNER_ASSIGNMENT_ASSIGN
    case STAFF_PLANNER_ASSIGNMENT_ASSIGN_REQUEST:
      return {
        ...state,
        staffPlannerAssignmentAssignLoading: true,
        staffPlannerAssignmentAssignError: null,
      };
    case STAFF_PLANNER_ASSIGNMENT_ASSIGN_SUCCESS:
      return {
        ...state,
        staffPlannerAssignmentAssignLoading: false,
        staffPlannerAssignmentAssignSuccess: action.payload,
      };
    case STAFF_PLANNER_ASSIGNMENT_ASSIGN_FAIL:
      return {
        ...state,
        staffPlannerAssignmentAssignLoading: false,
        staffPlannerAssignmentAssignError: action.payload,
      };
    //STAFF_PLANNER_ASSIGNMENT_UNASSIGN
    case STAFF_PLANNER_ASSIGNMENT_UNASSIGN_REQUEST:
      return {
        ...state,
        staffPlannerAssignmentUnassignLoading: true,
        staffPlannerAssignmentUnassignError: null,
      };
    case STAFF_PLANNER_ASSIGNMENT_UNASSIGN_SUCCESS:
      return {
        ...state,
        staffPlannerAssignmentUnassignLoading: false,
        staffPlannerAssignmentUnassignSuccess: action.payload,
      };
    case STAFF_PLANNER_ASSIGNMENT_UNASSIGN_FAIL:
      return {
        ...state,
        staffPlannerAssignmentUnassignLoading: false,
        staffPlannerAssignmentUnassignError: action.payload,
      };
    default:
      return state;
  }
};

export default staffPlanner;
